import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

/* ---------------- POLYFILL (MUST BE FIRST) ---------------- */
if (typeof window !== "undefined") {
  if (!window.crypto) {
    window.crypto = {};
  }

  if (!window.crypto.randomUUID) {
    window.crypto.randomUUID = function () {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = window.crypto.getRandomValues(new Uint8Array(1))[0] & 15;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    };
  }
}

/* ---------------- DEBUG TOKEN ---------------- */
if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
  // use string "true" (more stable than boolean)
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = "true";
}

/* ---------------- FIREBASE CONFIG ---------------- */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

/* ---------------- INIT APP (SAFE) ---------------- */
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

/* ---------------- APP CHECK (SAFE INIT) ---------------- */
if (typeof window !== "undefined") {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(
        process.env.REACT_APP_RECAPTCHA_SITE_KEY
      ),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (err) {
    console.warn("AppCheck init failed:", err);
  }
}

/* ---------------- AUTH ---------------- */
const auth = getAuth(app);

export { auth };
export default app;